module.exports = __webpack_public_path__ + "static/Khong-2b4991152f22756cdf61dbbfd7de2086.jpg";